import { FlavourColorMap, FlavourNameMap, Flavour } from 'types/Flavour';

export const FLAVOUR_COLORS: FlavourColorMap = { full: '#35b8d3', semi: '#3fc599', skimmed: '#f1617d', archive: '' }
export const DEFAULT_FLAVOUR: Flavour = 'full'
export const ALL_FLAVOURS: string[] = ['full', 'semi', 'skimmed', 'archive']
export const FLAVOUR_TITLES: FlavourNameMap = { full: 'Full fat', semi: 'Semi-skimmed', skimmed: 'Skimmed', archive: 'Archive' }
